export const dropBoxStyle = {
    padding: "5px",
    height: "120px",
    boxSizing: "border-box",
    borderRadius: "3px",
    overflowY: "scroll",
    background: "#FBFCFC",
    border: "1px solid #9F9C9C"
  }as React.CSSProperties
  
export const placeHolderStyle = {
    color: "#99A3A4 ",
    fontSize: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }as React.CSSProperties
  
